











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class PromoCard extends Vue {
  @Prop({ default: '' }) header!: string;
}

